
import { MENU_NAME } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: MENU_NAME,
  props: ['menu', 'showCountFlag', 'mainFlag', 'count'],
  data () {
    return {
      companyType: this.$store.getters.companyType
    }
  }
})
